<div>
    <p-button  [style]="style" *ngFor="let option of options; let i = index" (click)="select(i)" [rounded]="true" class="ml-2" [icon]="option.icon" [label]="option.label" [severity]="active == i ? 'secondary': 'white'"></p-button>
</div>